export const crmDealsArticle = {
  title: 'Customer CRM: Deals Pipeline',
  slug: 'crm-deals-pipeline',
  content: `Customer CRM: Deals Pipeline

The Deals tab is your pipeline board for tracking opportunities.

1) Open the Deals board
- From /crm, select the Deals tab ("Deals").
- The board shows each opportunity grouped by stage.

2) Track opportunities
- Move deals through stages as they progress.
- Update deal values to keep revenue totals accurate.

3) Create new deals
- Create deals directly from the Deals tab or from a contact record.
- Add a clear title and expected value so reporting stays accurate.
`,
};
